import React from "react";
import "../../styles/loading-spinner.css";
var Error = function Error(_ref) {
    var _ref$errorMessage = _ref.errorMessage, errorMessage = _ref$errorMessage === void 0 ? "Ein Fehler ist aufgetreten" : _ref$errorMessage, children = _ref.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-1/3 justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center text-xl lg:text-2xl"
    }, errorMessage), children);
};
export default Error;
